<template>
  <div class="contents_wrapper login">
    <div class="login_wrap">
      <div class="login_icon">
        <img :src="$designResource.loginIcon" alt="loginIcon" />
      </div>
      <div class="login_form">
        <div class="login_input_wrap">
          <div class="login_mail_icon">
            <img :src="$designResource.loginMail" alt="mail" />
          </div>
          <div class="login_text">
            <input
              type="email"
              v-model="mail"
              autocomplete="off"
              @keyup.enter="getLoginInfo"
              placeholder="メールアドレス"
              class="login_text_input"
            />
          </div>
        </div>
        <button
          @click="getLoginInfo"
          class="login_form_button"
          v-bind:class="{'loading': isLoading}"
        >次へ</button>
        <div class="login_alert" v-html="message"></div>
      </div>
      <div class="login_kiyaku">
        <a v-bind:href="termsUrl" target="_blank" class="login_kiyaku_link">
          <img :src="$designResource.loginArrow" alt="arrow" />
          <span class="login_kiyaku_text">利用規約</span>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import AccountService from "../services/accountService";
import loggerService from "../services/loggerService";
import UserService from "../services/userService";
import Store from "../store";
import { PageUrl } from "../appConfig";

const store = new Store();

export default {
  data: function() {
    return {
      isLoading: false,
      termsUrl: PageUrl.Terms,
      mail: store.account,
      message: ""
    };
  },
  created: function() {
    loggerService.pageView("Login");
    if (this.$route.query["sessionOut"]) {
      this.message =
        "セッションの期限が切れました<br>もう一度ログインしてください";
      loggerService.info("sessionOut");
    }
  },
  methods: {
    login: function() {
      loggerService.info("login");
      var _this = this;
      _this.message = "";
      AccountService.login(
        () => {
          _this.isLoading = false;
          UserService.getMyAccount().then(user => {
            store.account = user.id;
            store.mail = user.email;
            _this.$router.push({ path: "/main" });
          });
        },
        () => {
          _this.isLoading = false;
          _this.message = "ログインに失敗しました。<br>再度実行してください。";
          loggerService.info("login failed");
        }
      );
    },
    getLoginInfo: function() {
      var _this = this;
      _this.isLoading = true;
      store.account = this.mail;
      AccountService.getLoginInfo(this.mail).then(
        function(res) {
          store.loginInfo = res;
          _this.login();
        },
        function() {
          _this.isLoading = false;
          if (/＠/.test(_this.mail))
            _this.message = "全角＠が含まれています。半角で入力してください。";
          else
            _this.message =
              "テナントが見つかりません<br>入力値をご確認下さい。";
          loggerService.info("tenant not found");
        }
      );
    }
  }
};
</script>

<style lang="scss">
@charset "utf-8";
.contents_wrapper.login {
  overflow: auto;
}
.login_wrap {
  height: 100%;
  width: 70%;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  flex-direction: column;
}
.login_icon {
  text-align: center;
}
.login_icon > img {
  width: 140px;
}
.login_form {
  position: relative;
  padding: 70px 0 70px;
  box-sizing: border-box;
}
.login_input_wrap {
  width: 100%;
  display: flex;
}
.login_mail_icon {
  width: 25px;
  margin-right: 10px;
}
.login_text {
  width: calc(100% - 35px);
  border-bottom: 1px solid $txtColor;
}
.login_text_input {
  width: 100%;
  box-sizing: border-box;
  color: #b1b1b0;
  font-size: 16px;
  margin-bottom: 5px;
}
.login_text_input::placeholder {
  color: rgba(177, 177, 176, 1);
  font-size: 14px;
}
.login_form_button {
  width: 100%;
  color: #fff;
  background-color: $btnColor;
  padding: 10px;
  border-radius: 2px;
  margin-top: 60px;
  margin-bottom: 30px;
}
.login_alert {
  width: 100%;
  text-align: center;
  line-height: 1.4;
  min-height: 40px;
}
.login_kiyaku {
  text-align: center;
}
.login_kiyaku_link > img {
  width: 20px;
}
.login_kiyaku_icon {
  width: 20px;
}
.login_kiyaku_text {
  color: $txtColor;
  margin-left: 10px;
  line-height: 1.4;
}

@media screen and (min-width: 741px) {
  .login_wrap {
    width: 50%;
  }
}
</style>